<adm-loading-spinner
  [loadingSignal]="state.loading()"
  [hasNoData]="state.loading() === false"
  [noResultsMessage]="'Noget gik galt, da der blev forsøgt at hente driftsbeskeder'"></adm-loading-spinner>
@let incidents = state.incidents$ | async;
@if ((appState.isInErrorState$ | async) === false) {
  <div class="incidents list" [class.loading-blur]="state.loading()" [class.loading-blur--done]="!state.loading()">
    <div
      class="list__unit-header list__unit-header--fixed"
      matSort
      (matSortChange)="sortData($event)"
      [style.--list-unit-header-top]="appState.cssVarListUnitHeaderTop + 'px'"
      [style.--list-unit-header-translate-x]="appState.cssVarListUnitHeaderTranslateX + 'px'">
      <div class="col col--number" mat-sort-header="id">ID</div>
      <div class="col col--status" mat-sort-header="status">Status</div>
      <div class="col col--location" mat-sort-header="locationFullAddress">Lokation</div>
      <div class="col col--stationNumber" mat-sort-header="stationNumber">Ladepunkt</div>
      <div class="col col--category" mat-sort-header="category">Kategori</div>
      <div class="col col--created" mat-sort-header="created">Oprettet</div>
      <div class="col col--solved" mat-sort-header="solved">Løst</div>
      <div class="col col--createdBy" mat-sort-header="createdBy">Oprettet af</div>
      <div class="col col--options"></div>
      <div class="col col--toggle"></div>
    </div>
    @for (incident of incidents?.items; track $index) {
      <adm-incident-list-expandable [incident]="incident" (update)="state.triggerUpdate()" />
    }
  </div>
}
@if ((incidents?.items?.length ?? 0) === 0 && !state.loading()) {
  <div class="no-results align-center">
    <p>Der blev ikke fundet nogen driftsbeskeder</p>
  </div>
}
<mat-paginator
  #paginator
  [pageIndex]="state.filters().page.pageIndex"
  [pageSize]="state.filters().page.pageSize"
  [pageSizeOptions]="state.pageSizeOptions()"
  [length]="incidents?.totalCount || 0"
  (page)="onPageChanged($event)"
  color="accent"
  [disabled]="state.loading()">
</mat-paginator>
